<template>
	<div v-if="isLetbane" class="letbanenotfound">
		<span class="letbanenotfound__title">404</span>
		<span class="letbanenotfound__text">{{ $t('letbane.page_not_found') }}</span>
		<router-link :to="{ path: '/' }" :title="$t('letbane.buy_tickets_uppercase')" class="letbanenotfound__button reset-button">
			{{ $t('letbane.buy_tickets_uppercase') }}
		</router-link>
	</div>
	<div v-else class="not-found-container">
		<error-image />
		<div>
			<h2>{{ texts.title }}</h2>
			<span>{{ texts.description }}</span>
			<spacer />
			<text-button @click="restart">
				{{ texts.button }}
			</text-button>
		</div>
	</div>
</template>

<script>
import TextButton from '@/components/elements/TextButton'

export default {
	components: {
		TextButton,
	},
	data() {
		return {
			isLetbane: false,
		}
	},
	computed: {
		texts() {
			return this.$t('page_not_found')
		},
	},
	watch: {
		$route() {
			this.isLetbane = process.env.VUE_APP_NAME === 'letbane'
		},
	},
	created() {
		this.isLetbane = process.env.VUE_APP_NAME === 'letbane'
	},
	methods: {
		restart() {
			this.$router.push({ path: '/' })
		},
	},
}
</script>

<style lang="scss">
.not-found-container {
	width: 300px;
	margin: 4rem auto;
	text-align: center;
}

.letbanenotfound {
	width: 100%;
	height: calc(100vh - 7.1875rem);
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;

	&__title {
		font-weight: 700;
		font-size: 7.375rem;
		color: $letbane-color-identityred;
		margin-bottom: 0.8125rem;
		line-height: 1;
	}

	&__text {
		font-weight: 300;
		font-size: 1rem;
		color: $letbane-color-black;
		margin-bottom: 3.1875rem;
	}

	&__button {
		cursor: pointer;
		background-color: $letbane-color-identityred;
		color: $letbane-color-white !important;
		width: 100%;
		padding: 1.0625rem;
		border-radius: 0.375rem;
		text-align: center;
		box-sizing: border-box;
		text-decoration: none;
		transition: background-color 0.3s ease;

		&:hover {
			background-color: $letbane-color-identityred-hover;
		}

		&:focus {
			background-color: $letbane-color-identityred-pressed;
		}
	}
}
</style>
